import { Controller } from "@hotwired/stimulus";

const MOBILE_QUERY = "(max-width: 480px)";

export default class extends Controller {
  static targets = ["panel", "backdrop"];

  connect() {
    this.boundClose = this.closeOnOutsideClick.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose);
    this.#unlockBodyScroll();
  }

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close();
  }

  open() {
    this.panelTarget.hidden = false;
    if (this.hasBackdropTarget) this.backdropTarget.hidden = false;

    requestAnimationFrame(() => {
      this.panelTarget.classList.add("info-popover__panel--open");
      if (this.hasBackdropTarget) this.backdropTarget.classList.add("info-popover__backdrop--open");
    });
    document.addEventListener("click", this.boundClose);

    // Mobile presents this as a backdrop modal — `overflow: hidden` on body
    // alone doesn't stop iOS Safari from scrolling the page underneath via
    // touch, so freeze body position outright while it's open.
    if (window.matchMedia(MOBILE_QUERY).matches) this.#lockBodyScroll();
  }

  close() {
    this.panelTarget.classList.remove("info-popover__panel--open");
    document.removeEventListener("click", this.boundClose);
    this.#unlockBodyScroll();

    const duration = parseFloat(getComputedStyle(this.panelTarget).transitionDuration) * 1000;
    if (duration > 0) {
      this.panelTarget.addEventListener("transitionend", () => { this.panelTarget.hidden = true; }, { once: true });
    } else {
      this.panelTarget.hidden = true;
    }

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("info-popover__backdrop--open");
      if (duration > 0) {
        this.backdropTarget.addEventListener("transitionend", () => { this.backdropTarget.hidden = true; }, { once: true });
      } else {
        this.backdropTarget.hidden = true;
      }
    }
  }

  closeOnOutsideClick(e) {
    if (!this.element.contains(e.target)) this.close();
  }

  #lockBodyScroll() {
    if (document.body.dataset.scrollLocked) return;
    this.scrollY = window.scrollY;
    document.body.dataset.scrollLocked = "true";
    document.body.style.position = "fixed";
    document.body.style.top = `-${this.scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
  }

  #unlockBodyScroll() {
    if (!document.body.dataset.scrollLocked) return;
    delete document.body.dataset.scrollLocked;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, this.scrollY || 0);
  }
}
